import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import './../../Style/AddPurchaseTotal.scss'
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { AiFillAppstore } from "react-icons/ai";
import { Paper } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import './../../Style/TableStyle.scss'
import { MdEdit } from "react-icons/md";
import InsertOwner from "../Owners/InsertOwners";
import DataGridWithActions from '../../Components/DataGridWithActions';
import { GridHeader } from "./CapitalDepositGrid";
import Autocomplete from "@mui/material/Autocomplete";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddLinkButton, LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import OneFieldTotal from "../../Components/OneFieldTotal";

export default function CapitalDeposite() {
    // const currentYear = new Date().getFullYear();

    const loginEmail = LoginUserDetailed();
    const headers = authHeader();

    const { fiscalYear } = useContext(FiscalYearContext);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const [showDetails, setShowDetails] = useState(true);

    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        TransactionID: "",
        InvoiceNr: "",
        Date: "",
        ActionType: "",
        LedgerID: "",
        AccountID: "",
        SupplierID: "",
        Total: "",
        PaymentOptions: "",
        Coment: "",
        ModifiedByUser: ""
    });


    const [showEditModal, setShowEditModal] = useState(false);
    const [owners, setOwners] = useState([]);
    const [ledgers, setLedgers] = useState([]);
    const [accounts, setAccounts] = useState([]);

    // Kodi per Marrjen e informatave nga databaza
    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CapitalDeposite', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // Kodi per fshirjen e nje elementi ne databaz 
    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'CapitalDeposite' + `/${deleteItemId}`, { headers }
            );
            deleteAlert("Transaksioni është fshirë me sukses");
            fetchData();
        } catch (error) {
            deleteAlert("Transaksioni nuk është fshirë");
        }
    };

    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setFormData({
            TransactionID: item.TransactionID,
            InvoiceNr: item.InvoiceNr,
            Date: item.Date,
            ActionType: item.ActionType,
            AccountID: item.AccountID,
            SupplierID: item.SupplierID,
            Total: item.Total,
            PaymentOptions: item.PaymentOptions,
            LedgerID: item.LedgerID,
            Coment: item.Coment,
            ModifiedByUser: loginEmail,
        });
        setShowEditModal(true);
        setShowDetails(false);
        fetchAccounts(item.LedgerID);
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        if (formData.Date == null) {
            errorAlert("Plotëso daten");
            return;
        }
        if (formData.LedgerID == null) {
            errorAlert("Plotëso llogarinë kontabël");
            return;
        }
        if (formData.PaymentOptions == null) {
            errorAlert("Plotëso llogarinë Debitore");
            return;
        }
        if (formData.Coment == null) {
            errorAlert("Plotësoni komentin");
            return;
        }
        if (formData.Total == null) {
            errorAlert("Plotëso vlerën");
            return;
        }
        if (formData.AccountID == null) {
            errorAlert("Plotëso pronarin");
            return;
        }
        axios
            .put(ApiLink.API_URL + 'CapitalDeposite', formData, { headers })
            .then((response) => {
                setShowEditModal(false); // Close the edit modal
                setShowDetails(true);
                fetchData();
                updateAlert("Transaksioni është edituar me sukses");
            })
            .catch((error) => {
                console.log(error);
                // alert("Failed to update State");
                errorAlert("Transaksioni nuk është edituar me sukses")
            });
    };

    const fetchOwner = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 501 } });
            setOwners(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchLedger = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Ledger/Get_101_102_Ledgers', { headers });
            setLedgers(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchAccounts = async (ledgerID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: ledgerID } });
            setAccounts(response.data);
            // alert(formData.PaymentOptions)
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const totalAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        inv: ("CAD-" + fiscalYear + "-" + item.InvoiceNr),
        date: (item.Date.substring(0, 10)),
        client: item.AccountName_AccountID,
        account: item.AccountName_PaymentOptions,
        amount: item.Total,
        deleteItemId: item.TransactionID,
        rowInfo: item
    }));

    //Select list for Clients
    const handleAutocompleteChangeAccounts = (event, value) => {
        if (value) {
            setFormData(prevState => ({
                ...prevState,
                AccountID: value.AccountID
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                AccountID: ""
            }));
        }
    };

    const defaultPropsAccounts = {
        options: owners,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>

                </li>
            </>
        ),
    };

    const handleAutocompleteChangePayOptions = (event, value) => {
        if (value) {
            setFormData(prevState => ({
                ...prevState,
                PaymentOptions: value.AccountID
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                PaymentOptions: ""
            }));
        }
    };

    const defaultPropsPayOptions = {
        options: accounts,
        getOptionLabel: (option) =>
            option.AccountName || ""
    };

    useEffect(() => {
        fetchData();
        fetchOwner();
        fetchLedger();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <div className="shfaqeEditin">
                {/* Shfaqja  e modalit per editimin e te dhenave  */}
                {showEditModal && (
                    <div className="AddPurchaseTotal__Container">
                        <TitleElements
                            icon={MdEdit}
                            title="Ndrysho deponimin e kapitalit"
                        />
                        <hr></hr>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ display: "flex" }}>
                                <InsertOwner fetchData={fetchOwner} type="insert" />
                            </div>
                            <div style={{ display: "flex" }}>
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Ndrysho"
                                        // icon={<FaTrash />}
                                        link="#"
                                        onClick={handleSubmit}
                                    />
                                </div>
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Anulo"
                                        // icon={<FaTrash />}
                                        link="#"
                                        onClick={() => {
                                            setShowDetails(true);
                                            setShowEditModal(false);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className='header_paper2'></div> */}
                        <HeaderPaperComponent />
                        <div className="edit">
                            <form className='AddPurchaseTotal__Container__Format'>
                                <Paper>
                                    <Box
                                        component="form"
                                        sx={{
                                            '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    >
                                        <div className='Forma1'>
                                            <div className='Boxx'>
                                                <TextField
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                    // style={{ width: "594px" }}
                                                    id="InvoiceNr"
                                                    label="Numri Terheqjes"
                                                    variant="outlined"
                                                    type="text"
                                                    name='InvoiceNr'
                                                    value={"CAD-" + fiscalYear + "-" + formData.InvoiceNr}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                                <TextField
                                                    // style={{ width: "230px" }}
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                    id="Date"
                                                    type="date"
                                                    variant="outlined"
                                                    name='Date'
                                                    value={formData.Date.substring(0, 10)}
                                                    onChange={handleInputChange}
                                                    inputProps={{
                                                        min: minDate, // Kufizimi minimal i datës
                                                        max: maxDate, // Kufizimi maksimal i datës
                                                    }}
                                                />
                                                <hr style={{ marginLeft: "15px" }}></hr>
                                                <TextField
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                    id="LedgerID"
                                                    name="LedgerID"
                                                    select
                                                    label="Llogaria kontabel Kreditore"
                                                    defaultValue=""
                                                    value={formData.LedgerID}
                                                    onChange={(e) => { handleInputChange(e); fetchAccounts(e.target.value); }}
                                                >
                                                    {ledgers.map((data) => (
                                                        <MenuItem key={data.LedgerID} value={data.LedgerID}>
                                                            {data.LedgerNameEN}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>

                                                <Autocomplete
                                                    fullWidth
                                                    // sx={{ m: 2 }}
                                                    {...defaultPropsPayOptions}
                                                    id="PaymentOptions"
                                                    includeInputInList
                                                    onChange={handleAutocompleteChangePayOptions}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label="Llogaria Kreditore"
                                                            // variant="filled"
                                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                                        />
                                                    )}
                                                    ListboxProps={{
                                                        style: {
                                                            maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                            overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                        },
                                                    }}
                                                    value={accounts.find(option => option.AccountID === formData.PaymentOptions) || null}
                                                />
                                            </div>

                                            <div className='box2'>
                                                <div className='box3'>
                                                    <TextField
                                                        // style={{ width: "495px" }}
                                                        className="AddPurchaseTotal__Container__Format__Comment"
                                                        type="text"
                                                        id="Coment"
                                                        name="Coment"
                                                        label="Komenti"
                                                        variant="outlined"
                                                        value={formData.Coment}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className='box3'>
                                                    <TextField
                                                        // style={{ width: "495px" }}
                                                        className="AddPurchaseTotal__Container__Format__Comment"
                                                        type="text"
                                                        id="Total"
                                                        name="Total"
                                                        label="Vlera"
                                                        variant="outlined"
                                                        value={formData.Total}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <hr style={{ marginRight: "65px" }}></hr>
                                                <TextField
                                                    className="AddPurchaseTotal__Container__Format__Comment"
                                                    id="outlined-basic"
                                                    label="Llogaria kontabel Debitore"
                                                    variant="outlined"
                                                    // name='Total'
                                                    value="501-Kapitali pronarit"
                                                    disabled
                                                />
                                                <Autocomplete
                                                    fullWidth
                                                    // sx={{ m: 2 }}
                                                    {...defaultPropsAccounts}
                                                    id="AccountID"
                                                    includeInputInList
                                                    onChange={handleAutocompleteChangeAccounts}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label="Pronari"
                                                            // variant="filled"
                                                            className="AddPurchaseTotal__Container__Format__Comment"
                                                        />
                                                    )}
                                                    ListboxProps={{
                                                        style: {
                                                            maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                            overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                        },
                                                    }}
                                                    value={owners.find(option => option.AccountID === formData.AccountID) || null}
                                                />
                                            </div>
                                        </div>
                                    </Box>
                                </Paper>

                            </form>
                        </div>
                    </div>
                )}
            </div>

            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Deponimi kapitalit"
                        />
                        <AddLinkButton
                            text="Krijo deponim kapitali"
                            icon="bi bi-plus-circle"
                            link="/money/addCapitalDeposit"
                        />
                    </div>
                    <ElementsParagraph text="Forma e deponimit te kapitalit: Menaxhoni, shtoni, editoni dhe fshini deponimin e kapitalit." />


                    <DataGridWithActions
                        columns={GridHeader}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={false}
                        height={500}
                    />

                    <OneFieldTotal
                        id={1}
                        label="Vlera"
                        value={totalAmount}
                    />
                </div>
            )}
        </div>
    )
}